import { createTheme } from '@mui/material';

/** Base colors */
export const COLORS = {
  /////////////////////////////////// NEUTRALS ///////////////////////////////////
  FLASH_WHITE: '#F3F3F3',
  LIGHT_WHITE: '#F9FBFB',
  GAINSBORO: '#DBDBDB',
  SILVER_SAND: '#C3C3C3',
  METALLICA: '#AAAAAB',
  ARTICHOKE: '#929293',
  LEAD: '#79797C',
  GRANITE: '#626263',
  OUTER_SPACE: '#49494B',
  CHARCOAL: '#313133',
  /////////////////////////////////// GREENS ///////////////////////////////////
  MINT_CREAM: '#F8FFF8',
  NYANZA: '#DBFFDB',
  GRASSY: '#4FC57E',
  SAGE: '#054628',
  /////////////////////////////////// PURPLES ///////////////////////////////////
  PERIWINKLE: '#F3EFFB',
  PLUM: '#E7DBFF',
  SOAP: '#CFBEEE',
  AMETHYST: '#875DD5',
  /////////////////////////////////// BLUES ///////////////////////////////////
  ALICE_BLUE: '#F2F6FF',
  ICEBERG: '#D6E0FF',
  NAVY: '#001149',
  MIDNIGHT: '#000A26',
  /////////////////////////////////// REDS/YELLOWS ///////////////////////////////////
  CHAMPAGNE: '#FCF6E5',
  AMBER: '#F2B50A',
  RUFOUS: '#A60F0F'
};

let theme = createTheme({
  palette: {
    error: {
      main: COLORS.RUFOUS
    },
    /////////////////////////////////// NEUTRALS ///////////////////////////////////
    flashWhite: {
      main: COLORS.FLASH_WHITE
    },
    lightWhite: {
      main: COLORS.LIGHT_WHITE
    },
    gainsboro: {
      main: COLORS.GAINSBORO
    },
    silverSand: {
      main: COLORS.SILVER_SAND
    },
    metallica: {
      main: COLORS.METALLICA
    },
    artichoke: {
      main: COLORS.ARTICHOKE
    },
    lead: {
      main: COLORS.LEAD
    },
    granite: {
      main: COLORS.GRANITE
    },
    outerSpace: {
      main: COLORS.OUTER_SPACE
    },
    charcoal: {
      main: COLORS.CHARCOAL
    },
    /////////////////////////////////// GREENS ///////////////////////////////////
    mintCream: {
      main: COLORS.MINT_CREAM
    },
    nyanza: {
      main: COLORS.NYANZA
    },
    grassy: {
      main: COLORS.GRASSY
    },
    sage: {
      main: COLORS.SAGE
    },
    /////////////////////////////////// PURPLES ///////////////////////////////////
    periwinkle: {
      main: COLORS.PERIWINKLE
    },
    plum: {
      main: COLORS.PLUM
    },
    soap: {
      main: COLORS.SOAP
    },
    amethyst: {
      main: COLORS.AMETHYST
    },
    /////////////////////////////////// BLUES ///////////////////////////////////
    aliceBlue: {
      main: COLORS.ALICE_BLUE
    },
    iceberg: {
      main: COLORS.ICEBERG
    },
    navy: {
      main: COLORS.NAVY
    },
    midnight: {
      main: COLORS.MIDNIGHT
    },
    /////////////////////////////////// REDS/YELLOWS ///////////////////////////////////
    champagne: {
      main: COLORS.CHAMPAGNE
    },
    amber: {
      main: COLORS.AMBER
    },
    rufous: {
      main: COLORS.RUFOUS
    }
  },
  typography: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    fontWeightBold: 600,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    allVariants: {
      letterSpacing: 0
    },
    // Base Typography styles
    display1: {
      fontSize: '4rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    display2: {
      fontSize: '3.5rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    display3: {
      fontSize: '3rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    display4: {
      fontSize: '2.25rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    display5: {
      fontSize: '1.75rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    display6: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    display7: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '100%'
    },
    xlBold: {
      fontSize: '1.5rem',
      fontWeight: 500,
      lineHeight: '150%'
    },
    lgBold: {
      fontSize: '1.25rem',
      fontWeight: 500,
      lineHeight: '160%'
    },
    mdBold: {
      fontSize: '1rem',
      fontWeight: 500,
      lineHeight: '150%'
    },
    smBold: {
      fontSize: '0.875rem',
      fontWeight: 500,
      lineHeight: '170%'
    },
    xsBold: {
      fontSize: '0.75rem',
      fontWeight: 500,
      lineHeight: '130%'
    },
    xl: {
      fontSize: '1.5rem',
      fontWeight: 400,
      lineHeight: '1.5'
    },
    lg: {
      fontSize: '1.25rem',
      fontWeight: 400,
      lineHeight: '1.5'
    },
    md: {
      fontSize: '1rem',
      fontWeight: 400,
      lineHeight: '1.5'
    },
    sm: {
      fontSize: '0.875rem',
      fontWeight: 400,
      lineHeight: '1.5'
    },
    xs: {
      fontSize: '0.75rem',
      fontWeight: 400,
      lineHeight: '1.5'
    }
  }
});

theme = createTheme(theme, {
  typography: {
    h1: theme.typography.display1,
    h2: theme.typography.display2,
    h3: theme.typography.display3,
    h4: theme.typography.display4,
    h5: theme.typography.xlBold,
    h6: theme.typography.lgBold,
    subtitle1: theme.typography.xl,
    subtitle2: theme.typography.lg,
    body1: theme.typography.md,
    body2: theme.typography.sm,
    button: theme.typography.md,
    caption: theme.typography.xs
  }
});

export default theme;
